import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useSearchParams } from "react-router-dom";
import useProductContent from "../hooks/useProductContent";
import Description from "./Description";
import ReturnDetail from "./ReturnDetail";
import PinCodeSection from "./PinCodeSection";
import QuantitySelectSection from "./QuantitySelectSection";
import ColorSelecterSection from "./ColorSelecterSection";
import SizeSelectSection from "./SizeSelectSection";
import PriceDetailsSection from "./PriceDetailsSection";
import AddToCartButton from "./AddToCartButton";
import { Heart, LocationTick } from "iconsax-react";
import { Player } from "@lottiefiles/react-lottie-player";
import heartAnimation from "../../../../assets/icons/Heart.json";
import LoginPromptModal from "../../../../components/LoginModal/LoginPromptModal";
import { ToastContainer, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function ProductContent({ productSlug }) {
  const [searchParams] = useSearchParams();
  const sku = searchParams.get("sku");
  const {
    loading,
    productDetails,
    selectedSize,
    selectedColor,
    setSelectedColor,
    quantity,
    setQuantity,
    currentPrice,
    localLoading,
    unit,
    setUnit,
    sizeSelection,
    selectionColor,
    pincode,
    isPincodeLocked,
    setPincode,
    handleCheck,
    pinloading,
    handleReset,
    pincodeDetails,
    handleAddToCart,
    toggleWishlist,
    showLoginPrompt,
    setShowLoginPrompt,
    setSelectedSize,
    collection,
    availProductMessage
  } = useProductContent(productSlug, sku);


  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        style={{ zIndex: 9999999 }}
        limit={1}
        hideProgressBar
        transition={Slide}
        newestOnTop
      />

      <div className="product-info" style={{ paddingTop: "9px" }}>

        {/* TITLE */}
        <div className="title-wrapper">
          {/* COLLECTION */}
          {localLoading ? (
            <Skeleton width={140} height={18} />
          ) : (
            <span
              className="product-collection"
              style={{ fontSize: "14px", display: "block" }}
            >
              {collection || productDetails?.collection || ""}
            </span>
          )}

          {/* PRODUCT NAME */}
          {localLoading ? (
            <Skeleton width={260} height={28} style={{ marginTop: 6 }} />
          ) : (
            <h1 className="title_details">
              {selectedSize?.name || productDetails?.name}
            </h1>
          )}

        </div>

        {/* PRICE */}
        <PriceDetailsSection
          localLoading={localLoading}
          currentPrice={currentPrice}
          selectedSize={selectedSize}
        />

        {/* SIZE */}
        <SizeSelectSection
          localLoading={localLoading}
          productDetails={productDetails}
          selectedSize={selectedSize}
          setSelectedSize={setSelectedSize}
          unit={unit}
          setUnit={setUnit}
          sizeSelection={sizeSelection}
          setQuantity={setQuantity}
        />

        {/* COLOR */}
        <ColorSelecterSection
          loading={loading}
          selectedSize={selectedSize}
          selectedColor={selectedColor}
          setSelectedColor={setSelectedColor}
          selectionColor={selectionColor}
          setQuantity={setQuantity}
          colorsku={sku}
        />

        {/* QUANTITY */}
        <QuantitySelectSection
          localLoading={localLoading}
          quantity={quantity}
          setQuantity={setQuantity}
          selectedSize={selectedSize}
        />

        {/* PINCODE */}
        <PinCodeSection
          localLoading={localLoading}
          pincode={pincode}
          setPincode={setPincode}
          isPincodeLocked={isPincodeLocked}
          handleCheck={handleCheck}
          pinloading={pinloading}
          handleReset={handleReset}
          pincodeDetails={pincodeDetails}
          LocationTick={LocationTick}
        />

        {/* ADD TO CART */}
        <AddToCartButton
          loading={localLoading}
          handleAddToCart={handleAddToCart}
          quantity={quantity}
          selectedSize={selectedSize}
          toggleWishlist={toggleWishlist}
          Player={Player}
          heartAnimation={heartAnimation}
          Heart={Heart}
          AvailProductMessage={availProductMessage}
        />

        {/* RETURN */}
        <ReturnDetail
          localLoading={localLoading}
          productDetails={productDetails}
        />

        {/* DESCRIPTION */}
        <Description details={productDetails} />

      </div>
      {showLoginPrompt && (
        <LoginPromptModal onClose={() => setShowLoginPrompt(false)} />
      )}
    </>
  );
}
export default ProductContent;